// Copyright (c) 2022, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";

import { Route, Routes, useParams } from "react-router-dom";

export const DailyRoom = () => {
  const { id } = useParams();
  const dailyRoomName = id.replace(/-/g, "");
  const dailyRoomUrl = `https://tegsaude.daily.co/${dailyRoomName}`;
  window.location.replace(dailyRoomUrl);
  return <></>;
};

export const RedirectRoutes = () => {
  return (
    <Routes>
      <Route path="redirect-dailyco/:id" element={<DailyRoom />} />
    </Routes>
  );
};
